$(".radio-option-outer.onetime-outer").click(function(){
  $(".one_benefits").show();
  $(".subscribe_benefits").hide();
})
$(".radio-option-outer.subscribe-outer").click(function(){
  $(".one_benefits").hide();
  $(".subscribe_benefits").show();
})
$("p.qa_question").each(function(){
  $(this).click(function(){
    console.log("question clicked")
    $(this).parent().find(".collapse").toggle();
    $(this).find("i.fa.fa-minus").toggle();
    $(this).find("i.fa.fa-plus").toggle();
  })
})
$('.honest_reviews_mobile').slick();
$('.related_products_app_body').slick();
var features_list = $(".product-features").html();
var product_all_details = $(".accordionEntry0").html();
$(".product_all_details").html(product_all_details);
$(".accordionEntry0").html(features_list).append("<a class = 'more_details'>View all Details</a>");
$("a.more_details").click(function(){
  $(".product_details_content").css("display","flex");
  $('body').css('overflow', 'hidden');

  $(".all_details").show();
  $(".size_chat").hide();
  $(".day_chat").hide();
});
setTimeout(() => {
  $("span.what_how").click(function(){
    $(".product_details_content").css("display","flex")
    $(".size_chat").show();
    $(".day_chat").hide();
    $(".all_details").hide()
  });

  $("span.how_what").click(function(){
    $(".product_details_content").css("display","flex")
    $(".size_chat").hide();
    $(".day_chat").show();
    $(".all_details").hide()
  });
  $(".close_icon img").click(function(){
    $(".product_details_content").css("display","none");
    $('body').css('overflow', '');
  });
},1000)

setInterval(() => {
  const totalPrice = Number($(".radio-option-outer.radio-checked span.price-text span.total-price").text().replace('$', ''));
  const pricePerItem = $(".price-per-item").text()
  const currentValue = $(".current_price").text()

  const selectedQuantity = Number($(".subproduct-selectors .Quantity select :selected").val());

  if (selectedQuantity && totalPrice) {
    const pricePerPiece = totalPrice / selectedQuantity;
    return `$${pricePerPiece.toFixed(2)}/piece`;
  }

  const newValue = `From ${pricePerItem}`
  if (currentValue !== newValue) {
    $(".current_price").text(newValue)
  }

  if($( window ).width()<760){
    const newBtnText = "Add To Cart" + " | " + $(".current_price").text();
    const oldBtnText = $(".btn_add input.add-to-cart-btn").val()
    if (newBtnText !== oldBtnText) {
      $(".btn_add input.add-to-cart-btn").val(newBtnText)
    }
  }
}, 500);

var timer = setInterval(() => {
  if($("h4.related_products_app_title").length > 0){
    $("h4.related_products_app_title").each(function() {
      $(this).prepend("<h3 class = 'brand_name'>Because</h3>");
    })
    $("span.related_products_app_regularprice").prepend("<span>From</span>")
    clearInterval(timer)
  }
}, 200);
